import {
    addComponent,
    defineQuery,
    enterQuery,
    exitQuery,
    hasComponent,
    Not,
    removeComponent,
} from "bitecs";
import { SoundComponent } from "../components/SoundComponent";
import { TagPetComponent } from "../components/TagPetComponent";
import { TagTouchedComponent } from "../components/TagTouchedComponent";
import { Sounds } from "../Sounds";
import { TinyPetsWorld } from "../TinyPetsWorld";

export const createPetSoundSystem = (
    world: TinyPetsWorld,
    config: {}
): {
    petSoundSystem: (world: TinyPetsWorld) => TinyPetsWorld;
} => {
    const MEOW_ADDED_COOLDOWN_MS = 20000;
    const MEOW_MIN_COOLDOWN_MS = 5000;

    const entityQuery = defineQuery([
        TagPetComponent,
        Not(TagTouchedComponent),
    ]);
    const enteredQuery = enterQuery(entityQuery);

    const touchedQuery = defineQuery([TagPetComponent, TagTouchedComponent]);
    const touchedEnteredQuery = enterQuery(touchedQuery);
    const touchedExitedQuery = exitQuery(touchedQuery);

    const petMeows: { [eid: number]: { cooldown: number } } = {};

    return {
        petSoundSystem: (world: TinyPetsWorld) => {
            // apply logic to entities added to the query
            const entered = enteredQuery(world);
            for (let i = 0; i < entered.length; i++) {
                const eid = entered[i];

                petMeows[eid] = {
                    cooldown:
                        MEOW_MIN_COOLDOWN_MS +
                        MEOW_ADDED_COOLDOWN_MS * Math.random(),
                };
            }

            const entities = entityQuery(world);
            for (let i = 0; i < entities.length; i++) {
                const eid = entities[i];

                petMeows[eid].cooldown -= world.time.delta;

                if (petMeows[eid].cooldown <= 0) {
                    if (!hasComponent(world, SoundComponent, eid)) {
                        addComponent(world, SoundComponent, eid);
                    }

                    SoundComponent.soundLocation[eid].set([Sounds.CAT_MEOW]);
                    SoundComponent.autoplay[eid] = 1;
                    SoundComponent.rate[eid] = 1;
                    SoundComponent.volume[eid] = 0.3;
                    SoundComponent.dirty[eid] = 1;

                    petMeows[eid].cooldown =
                        MEOW_MIN_COOLDOWN_MS +
                        MEOW_ADDED_COOLDOWN_MS * Math.random();
                }
            }

            // apply logic to entities added to the query
            const enteredTouched = touchedEnteredQuery(world);
            for (let i = 0; i < enteredTouched.length; i++) {
                const eid = enteredTouched[i];

                if (!hasComponent(world, SoundComponent, eid)) {
                    addComponent(world, SoundComponent, eid);
                }

                SoundComponent.soundLocation[eid].set([Sounds.CAT_PURR]);
                SoundComponent.autoplay[eid] = 1;
                SoundComponent.loop[eid] = 1;
                SoundComponent.rate[eid] = 0.8;
                SoundComponent.volume[eid] = 1;
                SoundComponent.dirty[eid] = 1;
            }

            // apply logic to entities leaving to the query
            const exitTouched = touchedExitedQuery(world);
            for (let i = 0; i < exitTouched.length; i++) {
                const eid = exitTouched[i];

                if (hasComponent(world, SoundComponent, eid)) {
                    removeComponent(world, SoundComponent, eid);
                }
            }

            return world;
        },
    };
};
